import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import RoutableSitecoreLink from '../routableSitecoreLink';
import { TStyledLinkProps } from './types/styledLink.types';
import { iconSize } from '../../../constants/icon.constants';
import Icon from '../icon';
import './styles.scss';

const StyledLink: FC<TStyledLinkProps> = ({ field, href, children, target = '' }) => {
  const linkComponent = field ? <RoutableSitecoreLink field={field} target={target} /> : <Link to={href || '#'}>{children}</Link>;
  return (
    <span className="link-with-arrow">
      {linkComponent}
      <Icon iconName="arrow-chevron-right" color="primary" size={iconSize.tbl} />
    </span>
  );
};

export default StyledLink;
